import { useState } from "react";
import { UserPlus, Send, CheckCircle2 } from "lucide-react";
import api from "../../services/api";

export default function ReferralForm() {
  var formState = useState({ name: "", phone: "", email: "", product_interest: "", notes: "" });
  var form = formState[0];
  var setForm = formState[1];
  var savingState = useState(false);
  var saving = savingState[0];
  var setSaving = savingState[1];
  var sentState = useState(false);
  var sent = sentState[0];
  var setSent = sentState[1];

  function handleChange(field, value) {
    setForm(function(prev) { var n = {}; for (var k in prev) n[k] = prev[k]; n[field] = value; return n; });
  }

  function handleSubmit(e) {
    e.preventDefault();
    setSaving(true);
    var payload = { name: form.name, phone: form.phone };
    if (form.email) payload.email = form.email;
    if (form.product_interest) payload.product_interest = form.product_interest;
    if (form.notes) payload.notes = form.notes;
    api.post("/referrals", payload).then(function() {
      setSent(true);
      setForm({ name: "", phone: "", email: "", product_interest: "", notes: "" });
      setTimeout(function() { setSent(false); }, 4000);
    }).finally(function() { setSaving(false); });
  }

  return (
    <div className="bg-white rounded-xl lg:rounded-2xl p-4 lg:p-6 shadow-sm border border-gray-100" data-testid="referral-form-section">
      <div className="flex items-center gap-2 mb-4">
        <div className="p-2 bg-[#F26A4B]/10 rounded-xl"><UserPlus className="w-5 h-5 text-[#F26A4B]" /></div>
        <h3 className="text-base lg:text-lg font-bold text-[#0A2F3D]">Indique um Amigo</h3>
      </div>
      <p className="text-xs text-gray-500 mb-4">Conhece alguem que precisa de um seguro ou consórcio? Indique e concorra!</p>

      {sent ? (
        <div className="flex items-center gap-3 p-4 bg-emerald-50 rounded-xl border border-emerald-100" data-testid="referral-success">
          <CheckCircle2 className="w-5 h-5 text-emerald-500 flex-shrink-0" />
          <div>
            <p className="text-sm font-medium text-emerald-700">Indicacao enviada com sucesso!</p>
            <p className="text-xs text-emerald-600">Nosso time entrara em contato em breve.</p>
          </div>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-3">
          <div>
            <input required value={form.name} onChange={function(e) { handleChange("name", e.target.value); }} placeholder="Nome do indicado" className="w-full px-3 py-2.5 border rounded-xl text-sm" data-testid="referral-name" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <input required value={form.phone} onChange={function(e) { handleChange("phone", e.target.value); }} placeholder="Telefone" className="w-full px-3 py-2.5 border rounded-xl text-sm" data-testid="referral-phone" />
            <input value={form.email} onChange={function(e) { handleChange("email", e.target.value); }} placeholder="Email (opcional)" className="w-full px-3 py-2.5 border rounded-xl text-sm" data-testid="referral-email" />
          </div>
          <select value={form.product_interest} onChange={function(e) { handleChange("product_interest", e.target.value); }} className="w-full px-3 py-2.5 border rounded-xl text-sm text-gray-600" data-testid="referral-product">
            <option value="">Interesse em... (opcional)</option>
            <option value="consorcio">Consorcio</option>
            <option value="seguro_auto">Seguro Auto</option>
            <option value="seguro_residencial">Seguro Residencial</option>
            <option value="seguro_vida">Seguro Vida</option>
            <option value="seguro_empresarial">Seguro Empresarial</option>
          </select>
          <textarea value={form.notes} onChange={function(e) { handleChange("notes", e.target.value); }} placeholder="Alguma observacao? (opcional)" rows={2} className="w-full px-3 py-2.5 border rounded-xl text-sm" data-testid="referral-notes" />
          <button type="submit" disabled={saving} className="w-full flex items-center justify-center gap-2 px-4 py-2.5 bg-[#F26A4B] text-white rounded-xl text-sm font-medium hover:bg-[#e05535] transition-colors disabled:opacity-50" data-testid="referral-submit">
            <Send className="w-4 h-4" />{saving ? "Enviando..." : "Enviar Indicacao"}
          </button>
        </form>
      )}
    </div>
  );
}
